import { Box } from '@mui/material';
import { Icon } from '@/components/ui';
import { background } from '@/assets';
import type { FC } from 'react';

interface BackgroundProps {
  login?: boolean;
}

export const Background: FC<BackgroundProps> = ({ login }) => {
  return (
    <Box
      sx={{
        position: 'fixed',
        minWidth: '100%',
        width: '100%',
        bottom: login ? '0' : '40px',
        height: 'auto',
        overflow: 'hidden',
        left: 0,
        zIndex: -1,
      }}
    >
      <Icon
        sx={{
          maxWidth: '140%',
          minWidth: '140%',
          marginLeft: '-25%',
          height: 'auto',
        }}
        src={background}
      />
    </Box>
  );
};
